<!-- 图表 -->
<template>
  <div class="box">
    <tab-list-header :list="tabList" :cur-index="curIndex" @clickTab="clickTab"/>
    <!-- 图表 -->
    <component
      :is="chartType"
      :line-chart-type="curTab.tabValue"
      :fund-code="fundCode"
      :basic-info="basicInfo"
      :detail-info="detailInfo"
      :period="period"  />
    <!-- 时间选择 -->
    <period-switch-tab
      v-if="showPeriodSwitch"
      :basic-info="basicInfo"
      @periodChange="periodChange" />
  </div>
</template>

<script>
import config from '../../configs/default';
import TabListHeader from './TabListHeader.vue';
import PeriodSwitchTab from './PeriodSwitchTab.vue';
import FundLineChart from './FundLineChart.vue';
import TimeSharingChart from './TimeSharingChart.vue';
import FundKLine from './FundKLine.vue';

const NO_PERIOD_SWITCH = ['time-sharing-chart', 'fund-k-line'];

const CHART_TYPE_MAP = {
  line: 'fund-line-chart',
  timeSharing: 'time-sharing-chart',
  kLine: 'fund-k-line',
  dynamicLine: 'fund-dyn-line',
};

export default {
  name: 'fund-chart-tab',

  components: {
    TabListHeader,
    PeriodSwitchTab,
    FundLineChart,
    TimeSharingChart,
    FundKLine,
  },

  props: {
    fundCode: {
      type: String,
      default: '',
    },
    fundType: {
      type: String,
      default: '',
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      curIndex: 0, // 当前选中tabIndex
      period: 'n', // 当前选中的时间范围
    };
  },

  computed: {
    // tab头列表
    tabList() { // h5都不展示净值估算：产品 张文晓
      const {
        isCurrencyFund,
        isETF,
        isGoldFund,
      } = this.basicInfo;
      const tabConfig = { ...config.fundChartTabList };
      if (isCurrencyFund) return tabConfig.currency;
      if (isETF) return tabConfig.ETF;
      if (isGoldFund) return tabConfig.gold;
      return tabConfig.indexFund;
    },
    curTab() {
      return this.tabList[this.curIndex];
    },
    chartType() { // 图表类型
      return CHART_TYPE_MAP[this.curTab?.chartType] || '';
    },
    showPeriodSwitch() {
      return !NO_PERIOD_SWITCH.includes(this.chartType);
    },
  },

  methods: {
    clickTab(index) {
      console.log('clickTab=======', index);
      const eventNames = ['wxpzy.jjtb.ljsy.click', 'wxpzy.jjtb.dwjz.click', 'wxpzy.jjtb.ljjz.click', 'wxpzy.jjtb.jzgs.click'];
      const eventName = eventNames[index];
      this.$wxSendTrack(eventName, 'Click', { infoCode: this.fundCode, infoCodeType: '5' });
      this.curIndex = index;
    },
    periodChange(params) {
      this.period = params?.value || this.period;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  padding-top: 24px;
  padding-bottom: 24px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 12px;
}
</style>
